import IndexPage from '../layout/indexPage.vue'
import { RouteRecordRaw } from 'vue-router'


const routes: Array<RouteRecordRaw> = [
  {
    path: '/home',
    name: 'IndexPage',
    component: IndexPage,
    children: [
      { path: '/home/trend-draw-statistics', name: 'trend-draw-statistics', meta: { title: '模拟摇奖统计', requiresAdmin: true }, component: () => import('../views/TrendDrawStatistics.vue') },
      { path: '/home/dlt-poster', name: 'dlt-poster', meta: { title: '大乐透海报', requiresAdmin: true }, component: () => import('../views/DltPoster.vue') },
      { path: "/home/account-logs", name: "account-logs", meta: { title: "账号日志", requiresAdmin: true }, component: () => import("../views/AccountLogs.vue") },
      {
        path: '/home/conversion-scripts', name: 'conversion-scripts',
        meta: { title: '话术管理', requiresAdmin: true },
        component: () => import('../views/ConversionScripts.vue')
      },
      {
        path: "/home/douyin-users",
        name: "douyin-users",
        meta: { title: "抖音用户", requiresAdmin: true },
        component: () => import("../views/DouyinUsers.vue")
      },
      {
        path: '/home/trend-media',
        name: 'trend-media',
        meta: { title: '电视媒体', requiresAdmin: true },
        component: () => import('../views/TrendMedia.vue')
      },
      {
        path: '/home/trend-app-updates',
        name: 'trend-app-updates',
        meta: { title: '电视 App 更新', requiresAdmin: true },
        component: () => import('../views/TrendAppUpdates.vue')
      },
      {
        path: '/home/lottery-history',
        name: 'lottery-history',
        meta: { title: '开奖数据', requiresAdmin: true },
        component: () => import('../views/LotteryHistory.vue')
      },
      {
        path: '/home/timed-task-management',
        name: 'timed-task-management',
        meta: {
          title: '定时任务管理'
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/TimedTaskManagement.vue')
      },

      {
        path: '/home/match-list',
        name: 'match-list',
        meta: {
          title: '比赛列表'
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/MatchList.vue')
      },
      {
        path: '/home/user-management',
        name: 'user-management',
        meta: {
          title: '用户管理'
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/UserManagement.vue')
      },
      {
        path: '/home/watermark',
        name: 'watermark',
        meta: {
          title: '水印管理',
          allowBusiness: true
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/WaterMark.vue')
      },
      {
        path: '/home/history-match-list',
        name: 'history-match-list',
        meta: {
          title: '历史比赛列表'
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/HistoryMatchList.vue')
      },
      {
        path: '/home/role-list',
        name: 'role-list',
        meta: {
          title: '角色列表'
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/RoleListView.vue')
      },
      {
        path: '/home/dict-list',
        name: 'dict-list',
        meta: {
          title: '字典列表'
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/dictManage.vue')
      },
      {
        path: '/home/file-list',
        name: 'file-list',
        meta: {
          title: '文件列表'
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/fileManage.vue')
      },
      {
        path: '/home/store-management',
        name: 'store-management',
        meta: {
          title: '店铺管理'
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/storeManage.vue')
      },
      {
        path: '/home/league-list',
        name: 'league-list',
        meta: {
          title: '联赛信息'
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/LeagueList.vue')
      },
      {
        path: '/home/article-manage',
        name: 'article-manage',
        meta: {
          title: '文章管理'
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/ArticleManage.vue')
      },
      {
        path: '/home/analytics-dashboard',
        name: 'analytics-dashboard',
        meta: {
          title: '埋点分析'
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/AnalyticsDashboard.vue')
      },
      {
        path: '/home/team-roster',
        name: 'team-roster',
        meta: {
          title: '球队阵容'
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/TeamRoster.vue')
      },
    ]
  }
]


export default routes
